import React, { useEffect, useState } from 'react'
import CustomizedDialogs from '../../../common/CustomizedDialogs'
import { Box, Typography } from '@mui/material'
import TextBox from '../../../common/TextBox'
import DropDownV3 from '../../../common/DropDownV3'
import MButton from '../../../common/MButton'
import moment from 'moment'
import { useDispatch, useSelector } from 'react-redux'
import { genderOptList } from '../../Booking/constant'
import ModifyTable from './ModifyTable'
import '../../../style/modal/ModifyBooking/ModifyBookingModal.scss'
import { getBookingsModifyWithNameChangeV2 } from '../../../redux/Booking/BookingActions'
import { showErrorAlert, showSuccessAlert } from '../../../redux/Actions'
import { checkEmailValid } from '../../../utils/helpers'


const SectionHeader = ({ title }) => (
    <Box className="modifyBooking_sectionHeader">
        <Typography>{title}</Typography>
    </Box>
)

const ModifyBookingModal = (props) => {
    const {
        open = false,
        data = {},
        titleText = 'Modify Booking',
        onClose = () => { },
        handleResetTrip = () => { }
    } = props

    const dispatch = useDispatch()
    const store = useSelector((store) => store)
    const { user } = store
    const { userDetails } = user

    const [filterValue, setFilterValue] = useState({
        bkgPNRDetails: {},
        pickUp: [],
        dropOff: [],
        bkgSeat: [],
        name: '',
        phone: '',
        email: '',
    })

    const [filterOpt, setFilterOpt] = useState({
        pickUp: [],
        dropOff: [],
    })




    useEffect(() => {
        if (Object.keys(data).length !== 0) {
            let bkgPNRDetails = data?.Table?.[0] || {}
            let bkgSeat = data?.Table1?.map((obj) => {
                let gender = genderOptList?.filter((item) => item.id === obj.Gender)
                return { ...obj, Gender: gender.length > 0 ? [gender[0]] : [] }
            })
            let pickUpList = data?.pickUpList || []
            let dropOffList = data?.dropOffList || []
            let pickUp = pickUpList?.filter((obj) => obj.Pickup_ID === bkgPNRDetails?.PickupID)
            let dropOff = dropOffList?.filter((obj) => obj.Dropoff_ID === bkgPNRDetails?.DropoffID)
            setFilterValue((prev) => ({
                ...prev,
                bkgPNRDetails,
                bkgSeat,
                pickUp: pickUp.length > 0 ? [pickUp[0]] : [],
                dropOff: dropOff.length > 0 ? [dropOff[0]] : [],
                name: bkgSeat?.[0]?.PaxName || '',
                phone: bkgPNRDetails?.PassengerContactNo1 || '',
                email: bkgPNRDetails?.PassengerEmailID || '',
            }))

            setFilterOpt((prev) => ({
                ...prev,
                pickUp: pickUpList,
                dropOff: dropOffList,
            }))
        }
    }, [data])












    let bkgPNRDetails = filterValue?.bkgPNRDetails || {}

    const bookingTypeLabel =
        bkgPNRDetails?.BookingType === 'AP'
            ? 'PHONE'
            : bkgPNRDetails?.BookingType === 'AC'
                ? 'CONFIRM'
                : bkgPNRDetails?.BookingType || '-'

    const seatBerthLabel = filterValue?.bkgSeat?.map((obj) => obj.SeatNo).filter(Boolean).join(', ') || '-'



    const journeyFields = [
        { label: 'PNR', value: bkgPNRDetails?.BookingID },
        { label: 'Booking Type', value: bookingTypeLabel },
        { label: 'Total Fare', value: bkgPNRDetails?.FinishTotalFare ?? 0 },
        { label: 'Seat/Bert', value: seatBerthLabel },
        { label: 'Route', value: bkgPNRDetails?.SubRouteName || '' },
        {
            label: 'Chart',
            value: moment(bkgPNRDetails.ChartDateFormated).format('DD-MMM-YYYY') || ''

        },
        { label: 'From-To', value: '-' },
        {
            label: 'JDate/Time',
            value: `${moment(bkgPNRDetails.JourneyDate).format('DD-MMM-YYYY')} ${bkgPNRDetails?.JTime}` || '-',
        },
    ]



    const handleSave = () => {
        let bkgPNRDetails = filterValue?.bkgPNRDetails
        const name = filterValue?.name?.toString()?.trim() || ''
        const phone = filterValue?.phone?.toString()?.trim() || ''
        const email = filterValue?.email?.toString()?.trim() || ''
        let pickUp = filterValue?.pickUp || []
        let dropOff = filterValue?.dropOff || []
        const seats = (filterValue?.bkgSeat || []).map((row, index) => (
            index === 0 ? { ...row, PaxName: name || row?.PaxName } : row
        ))

        if (name === '') {
            dispatch(showErrorAlert('Enter Passenger Name', 'modifyName'))
            return
        }
        if (email !== '' && !checkEmailValid(email)) {
            dispatch(showErrorAlert('Invalid EmailID', 'modifyEmail'))
            return
        }
        if (phone === '') {
            dispatch(showErrorAlert('Enter Mobile No', 'modifyPhone'))
            return
        }
        if (!/^\d{10}$/.test(phone)) {
            dispatch(showErrorAlert('Invalid Mobile No', 'modifyPhone'))
            return
        }
        if (pickUp.length === 0) {
            dispatch(showErrorAlert('Select PickUp', 'modifyPickUp'))
            return
        }
        if (dropOff.length === 0) {
            dispatch(showErrorAlert('Select DropOff', 'modifyDropOff'))
            return
        }
        if (seats.length === 0) {
            dispatch(showErrorAlert('Least One Seat should be selected'))
            return
        }

        const errorMsg = []
        seats.forEach((obj) => {
            const seatErr = []
            const age = Number(obj?.Age)
            if (!obj?.PaxName?.toString()?.trim()) {
                seatErr.push('name')
            }
            if (!Array.isArray(obj?.Gender) || obj.Gender.length === 0) {
                seatErr.push('gender')
            }
            if (!obj?.Age?.toString()?.trim() || Number.isNaN(age) || age <= 0 || age > 120) {
                seatErr.push('age')
            }
            if (seatErr.length > 0) {
                errorMsg.push(
                    `Please provide ${seatErr.join(', ')} for passenger in seat ${obj.SeatNo || '(unknown)'}.`
                )
            }
        })
        if (errorMsg.length > 0) {
            dispatch(showErrorAlert(errorMsg.join('\n'), 'modifyName'))
            return
        }

        let basicTotal = seats.reduce((sum, obj) => sum + Number(obj.Fare), 0)
        const body = {
            intBookingID: bkgPNRDetails?.BookingID,
            intModificationType: 1,
            intNewTripID: bkgPNRDetails?.TripID,
            strGstN: '',
            strNewSeats: bkgPNRDetails?.SeatNos,
            strNewFares: basicTotal,
            dtNewJDate: moment(bkgPNRDetails?.JourneyDate).format('YYYY-MM-DD'),
            intFromCityId: bkgPNRDetails?.FromCityID,
            intToCityID: bkgPNRDetails?.ToCityID,
            dcmSeaterLow: bkgPNRDetails?.SeaterLow,
            dcmSeaterHigh: bkgPNRDetails?.SeaterHigh,
            dcmSleeperLow: bkgPNRDetails?.SleeperLow,
            dcmSleeperHigh: bkgPNRDetails?.SleeperHigh,
            dcmSlumberLow: bkgPNRDetails?.SlumberLow,
            dcmSlumberHigh: bkgPNRDetails?.SlumberHigh,
            dcmTotalFare: bkgPNRDetails?.TotalFare,
            intPickupID: pickUp?.[0]?.Pickup_ID,
            intDropoffID: dropOff?.[0]?.Dropoff_ID,
            strPassengerName: name,
            intUserID: 0,
            intAgentID: userDetails?.AgentID || 0,
            intBranchID: 0,
            intBranchUserID: 0,
            strTicketNo: bkgPNRDetails?.TicketNo || '',
            strPhone1: phone,
            strPhone2: '',
            intPayModeID: bkgPNRDetails?.PaymentModeID,
            intSwipeIssuerID: 0,
            strCardNo: '',
            intAgentUserID: userDetails?.AgentUserID || 0,
            strPaxDetails1: handlePaxDetails(seats?.[0] || {}, pickUp, dropOff),
            strPaxDetails2: handlePaxDetails(seats?.[1] || {}, pickUp, dropOff),
            strPaxDetails3: handlePaxDetails(seats?.[2] || {}, pickUp, dropOff),
            strPaxDetails4: handlePaxDetails(seats?.[3] || {}, pickUp, dropOff),
            strPaxDetails5: handlePaxDetails(seats?.[4] || {}, pickUp, dropOff),
            strPaxDetails6: handlePaxDetails(seats?.[5] || {}, pickUp, dropOff),
            strPaxDetails7: handlePaxDetails(seats?.[6] || {}, pickUp, dropOff),
            strPaxDetails8: handlePaxDetails(seats?.[7] || {}, pickUp, dropOff),
            strPaxDetails9: handlePaxDetails(seats?.[8] || {}, pickUp, dropOff),
            strPaxDetails10: handlePaxDetails(seats?.[9] || {}, pickUp, dropOff),
            strPaxDetails11: handlePaxDetails(seats?.[10] || {}, pickUp, dropOff),
            strPaxDetails12: handlePaxDetails(seats?.[11] || {}, pickUp, dropOff),
            intSeatCount: bkgPNRDetails?.Seatcount || 0,
            intGuestTypeID: 0,
            strEmailID: email,
            strRemarks: '',
            blnBackdateModify: moment(bkgPNRDetails.BookingDateFormated, 'DD-MMM-YYYY').isBefore(moment()),
        }

        dispatch(getBookingsModifyWithNameChangeV2(body)).then((res) => {
            if (res?.data?.status) {
                handleResetTrip()
                dispatch(showSuccessAlert("Successfully Updated"))
            } else {
                dispatch(showErrorAlert(res.data?.Message || ''))
            }
        })

    }

    const handlePaxDetails = (obj, pickUp = [], dropOff = []) => {
        if (Object.keys(obj).length > 0) {
            let pickUpFare = (pickUp?.length > 0 ? pickUp?.[0]?.pickupCharge_per === 0 ? pickUp?.[0]?.pickupCharge_rs : (Number(obj.Fare) * Number(pickUp?.[0]?.pickupCharge_per)) / 100 : 0)
            let dropOffFare = (dropOff?.length > 0 ? dropOff?.[0]?.dropoffCharge_per === 0 ? dropOff?.[0]?.dropoffCharge_rs : (Number(obj.Fare) * Number(dropOff?.[0]?.dropoffCharge_per)) / 100 : 0)
            return `1~${obj.SeatNo}~${obj.PaxName}~${obj?.Gender?.[0]?.id || 'M'}~${obj.Age || 0}~${obj.Fare}~${obj?.NationalityID}~~~~${pickUpFare}~${dropOffFare}`
        } else {
            return `1~~~M00~~~~~00`
        }
    }


    return (
        <CustomizedDialogs
            open={open}
            titleText={titleText}
            width="920px"
            height="auto"
            onClose={onClose}
            padding="0px"
        >
            <Box className="modifyBooking_page scrollBlueV8">
                <SectionHeader title="JOURNEY DETAILS" />
                <Box className="modifyBooking_sectionBody">
                    <Box className="modifyBooking_journeyGrid">
                        {journeyFields.map((field) => (
                            <Box className="smallTextBox28" key={field.label}>
                                <TextBox
                                    label={field.label}
                                    value={field.value ?? '-'}
                                    disabled
                                />
                            </Box>
                        ))}
                    </Box>
                    <Box className="modifyBooking_pickDropRow">
                        <Box className="smallDropDownp28">
                            <DropDownV3
                                width="100%"
                                name="PickUp"
                                id="modifyPickUp"
                                label="PickUp"
                                options={filterOpt?.pickUp || []}
                                preSelectedValues={filterValue?.pickUp || []}
                                isObject
                                primaryKey="Pickup_ID"
                                labelKey="label"
                                singleSelect
                                onSelect={(val) => {
                                    setFilterValue((prev) => ({
                                        ...prev,
                                        pickUp: val
                                    }))
                                }}
                            />
                        </Box>
                        <Box className="smallDropDownp28">
                            <DropDownV3
                                width="100%"
                                name="DropOff"
                                id="modifyDropOff"
                                label="DropOff"
                                options={filterOpt?.dropOff || []}
                                preSelectedValues={filterValue?.dropOff || []}
                                isObject
                                primaryKey="Dropoff_ID"
                                labelKey="label"
                                singleSelect
                                onSelect={(val) => {
                                    setFilterValue((prev) => ({
                                        ...prev,
                                        dropOff: val
                                    }))
                                }}
                            />
                        </Box>
                    </Box>
                </Box>

                <SectionHeader title="PASSENGER DETAILS" />
                <Box className="modifyBooking_sectionBody">
                    <Box className="modifyBooking_passengerGrid">
                        <Box className="smallTextBox28">
                            <TextBox
                                label="Name"
                                id="modifyName"
                                value={filterValue.name}
                                onChange={(e) => {
                                    setFilterValue((prev) => ({ ...prev, name: e.target.value }))
                                }}
                                onBlur={(e) => {
                                    let oldSeat = [...filterValue?.bkgSeat]
                                    oldSeat[0]['PaxName'] = e.target.value
                                    setFilterValue((prev) => ({ ...prev, bkgSeat: oldSeat }))
                                }}
                            />
                        </Box>
                        <Box className="smallTextBox28">
                            <TextBox
                                label="Phone"
                                id="modifyPhone"
                                value={filterValue.phone}
                                maxLength={10}
                                onChange={(e) => setFilterValue((prev) => ({ ...prev, phone: e.target.value }))}
                            />
                        </Box>
                        <Box className="smallTextBox28">
                            <TextBox
                                label="Email"
                                id="modifyEmail"
                                value={filterValue.email}
                                onChange={(e) => setFilterValue((prev) => ({ ...prev, email: e.target.value }))}
                            />
                        </Box>
                    </Box>
                </Box>

                <SectionHeader title="SEAT DETAILS" />
                <ModifyTable
                    seatRows={filterValue?.bkgSeat}
                    setFilterValue={setFilterValue}
                />

                <Box className="modifyBooking_btnSection">
                    <MButton className="btn-orange-outline" variant="outlined" btnName="Close" onClick={onClose} />
                    <MButton className="btn-orange" btnName="Save" onClick={handleSave} />
                </Box>
            </Box>
        </CustomizedDialogs>
    )
}

export default ModifyBookingModal
